<template>
  <section
    class="modal-box bg-brand-bg-main max-h-none max-w-none desktop:max-w-[32rem] w-full h-full rounded-none sm:rounded-2xl desktop:h-auto desktop:max-h-[calc(100vh_-_5em)]"
    :class="{ '!pt-0': stickyHeader }"
  >
    <slot name="actions">
      <header
        class="flex flex-row items-center gap-3 pb-2"
        :class="{
          'pt-[1.5rem] z-50 bg-brand-bg-main sticky top-0': stickyHeader,
        }"
      >
        <button
          class="btn btn-sm btn-circle p-2 w-auto h-auto bg-basics-bgdivider-10 text-brand-primary border-basics-bgdivider-10"
          v-bind="accessibilityButtonProps"
          @click="close"
        >
          <Icon icon="mdi:close" class="text-2xl" />
        </button>

        <p :id="labelId" class="modal-title">
          <slot name="title" :is-open="isOpen">{{
            $t("common.untitled")
          }}</slot>
        </p>
      </header>
    </slot>

    <slot :is-open="isOpen" />
  </section>
</template>

<script setup lang="ts">
import { Icon } from "@iconify/vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits<{
  close: [];
}>();

defineProps<{
  id?: string;
  labelId: string;
  isOpen: boolean;
  stickyHeader?: boolean;
}>();

const accessibilityButtonProps = {
  "data-dismiss": "modal",
  "aria-label": t("common.aria.close"),
};

const close = () => {
  emit("close");
};
</script>
